import React from "react"
import styled from "@emotion/styled"

const Container = styled.div`
  display: flex;
  background-color: #fafafa;
  flex-grow: 1;
`

const Content = styled.div`
  height: 100%;
  width: 100%;
`

const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const ChildrenWrapper = styled.div`
  flex-grow: 1;
`

type Props = {
  header: React.ReactNode
  children: React.ReactNode
}

const PageLayoutExtend = ({ header, children }: Props) => (
  <Container>
    <Content>
      <Hero>{header}</Hero>

      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Content>
  </Container>
)

export default PageLayoutExtend
